import { useMemo } from 'react';
import { getStaticLandingPage } from './landingpages/registry';

export function useLandingPage(pathname: string) {
  return useMemo(() => getStaticLandingPage(pathname), [pathname]);
}
